<template>
  <div style="font-size: 18rem;">
    <img style="padding:20rem;display: block;width:100rem;" src="../assets/hsraz/logo.png">
    <div style="padding:0 0 10rem 20rem;">
      关于App<span style="font-weight: bold;">海思分级阅读</span>:&nbsp;&nbsp;一款以原版RAZ分级绘本为内容载体,辅以练习的应用<br>
      <span style="font-weight: bold;padding-top:10rem;"><br>服务支持:<br></span>
      适用平台: iOS/Android<br>
      客服渠道: lianyang@tingtingyingyu.com
    </div>
    <div style="width:100%;height:1rem;background: #444;"></div>
    <div style="padding:20rem;font-size:24rem;align-items: center;display: flex;flex-direction: column;">
      <div style="width:20rem;height:20rem;padding:20rem;text-align:center;background: green;border-radius: 30rem;font-weight: 600;color: white;">1</div>
      <div style="width:50%;">海量绘本 科学分级<br>RAZ分级阅读是全球公认的英语启蒙和提升最佳教材，涵盖29个科学分级、2000+高质量绘本，兼顾故事与科普，满足从零基础到流利阅读的不同学习阶段。RAZ训练版App 基于语言学习规律，结合系统化训练流程，帮助孩子从“被动听读”到“主动运用”，真正掌握英语！</div>
      <img style="padding:20rem;width:30%;" src="../assets/hsraz/example1.png"/>
    </div>
    <div style="padding:20rem;font-size:24rem;align-items: center;display: flex;flex-direction: column;">
      <div style="width:20rem;height:20rem;padding:20rem;text-align:center;background: green;border-radius: 30rem;font-weight: 600;color: white;">2</div>
      <div style="width:50%;">科学分级 步步为赢<br>RAZ的体系严谨，按照词汇量、句子结构、阅读理解能力进行科学分级，帮涵盖29个科学分级、助孩子逐步提升阅读水平。无论孩子英语水平如何，都可以从合适的级别开始学习，从词汇到句子，从模仿到独立阅读，循序渐进，自然掌握英语。</div>
      <img style="padding:20rem;width:30%;" src="../assets/hsraz/example2.png"/>
    </div>
    <div style="padding:20rem;font-size:24rem;align-items: center;display: flex;flex-direction: column;">
      <div style="width:20rem;height:20rem;padding:20rem;text-align:center;background: green;border-radius: 30rem;font-weight: 600;color: white;">3</div>
      <div style="width:50%;">三遍阅读 四步训练 <br>海思RAZ训练版设计科学训练流程，帮助孩子真正掌握英语，家长无需摸索，按步骤练习即可看到明显效果！<br>第一步：单词学习——强化词汇理解； 第二步：单词游戏——趣味记忆，不再枯燥； 第三步：绘本学习（听绘本，跟读绘本，指读绘本）——科学提升阅读力；第四步：绘本游戏——深度理解，提升听力与阅读能力；第五步：学习报告——孩子的进步看得见。</div>
      <img style="padding:20rem;width:30%;" src="../assets/hsraz/example3.png"/>
    </div>
    <div style="padding:20rem;font-size:24rem;align-items: center;display: flex;flex-direction: column;">
      <div style="width:20rem;height:20rem;padding:20rem;text-align:center;background: green;border-radius: 30rem;font-weight: 600;color: white;">4</div>
      <div style="width:50%;">趣味训练 家长辅导神器<br>完整闭环学习，听-说-读-理解-测评，每个环节都有针对性训练，不是简单的“看一看、读一读”！<br>符合儿童语言学习规律，从词汇到句子，从模仿到独立阅读，循序渐进，自然掌握英语。<br>趣味训练，不枯燥：游戏化设计+语音测评+互动选择，让孩子边玩边学，提升学习兴趣。<br>家长无需经验，跟随App流程走，轻松带孩子进行科学训练，不再盲目摸索。</div>
      <img style="padding:20rem;width:30%;" src="../assets/hsraz/example4.png"/>
    </div>
    <div style="width:100%; background:#12151A;text-align: center;color:white;padding: 20rem;">
      <div>北京叔牙信息科技有限公司</div>
      <div style="padding-top:10rem;"><a style="color: white;" href="https://beian.miit.gov.cn/" target="_blank">京ICP备2021039423号-4A</a></div>
    </div>
  </div>
</template>

<script>

export default {
  components: { },
  data() {
    return {
    }
  },

  created() {
    console.log("route", window.location.href)
    document.title = '海思分级阅读'
  },

  methods: {
  },
}
</script>

<style scoped>
</style>
